"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sortable = exports.SortableState = exports.SortDirection = exports.CSS = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var timsort_1 = require("timsort");
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var image_button_1 = require("../button/image.button");
var icons_1 = require("../icon/icons");
var menu_1 = require("../menu/menu");
var menu_item_1 = require("../menu/menu.item");
var mithril_component_1 = require("../mithril.component");
var theme_1 = require("../theme");
exports.CSS = {
    container: 'c-Sortable',
    button: 'c-Sortable__Button',
    order: {
        ascending: 'c-Sortable__Ascending',
        descending: 'c-Sortable__Descending',
        container: 'c-Sortable__Order'
    }
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.button] = {
        color: theme_1.DefaultTheme.font.color.primary,
        padding: "0 ".concat(theme_1.DefaultTheme.space(1)),
        'font-family': theme_1.DefaultTheme.font.family,
        'font-weight': 'inherit',
        'text-transform': 'inherit'
    },
    _a[exports.CSS.order.ascending] = {
        'border-top': "1px solid ".concat(theme_1.DefaultTheme.font.color.divider)
    },
    _a));
var SortDirection;
(function (SortDirection) {
    SortDirection[SortDirection["ASCENDING"] = 1] = "ASCENDING";
    SortDirection[SortDirection["DESCENDING"] = -1] = "DESCENDING";
})(SortDirection || (exports.SortDirection = SortDirection = {}));
var SortIcon = (_b = {},
    _b[SortDirection.ASCENDING] = icons_1.MaterialIcon.KEY_UP,
    _b[SortDirection.DESCENDING] = icons_1.MaterialIcon.KEY_DOWN,
    _b);
var SortableState = /** @class */ (function () {
    function SortableState(sortOptions) {
        this.direction = SortDirection.DESCENDING;
        this.options = sortOptions;
        if (this.options.length > 0) {
            this.option = this.options[0];
        }
    }
    Object.defineProperty(SortableState.prototype, "isAscending", {
        get: function () {
            return this.direction === SortDirection.ASCENDING;
        },
        enumerable: false,
        configurable: true
    });
    SortableState.prototype.toggleDirection = function () {
        if (this.direction === SortDirection.ASCENDING) {
            this.direction = SortDirection.DESCENDING;
        }
        else {
            this.direction = SortDirection.ASCENDING;
        }
        this.track();
    };
    SortableState.prototype.setSort = function (sortOption) {
        this.option = sortOption;
        this.track();
    };
    SortableState.prototype.sortTags = function (objs) {
        return this.sortObjects(objs, 'tag');
    };
    SortableState.prototype.sortSummaries = function (objs) {
        return this.sortObjects(objs, 'collection');
    };
    SortableState.prototype.getCollectionDisplayValue = function (obj) {
        var currentOption = this.option;
        if (currentOption.info.collection == null || currentOption.info.collection === false) {
            return null;
        }
        if (currentOption.value != null && currentOption.value.collection != null) {
            return currentOption.value.collection(obj);
        }
        var sortKey = currentOption.keys.collection;
        if (typeof (sortKey) === 'string') {
            return obj[sortKey];
        }
        return sortKey(obj);
    };
    SortableState.prototype.sortObjects = function (objs, key) {
        var currentOption = this.option;
        var direction = this.direction;
        var sortKey = currentOption.keys[key];
        function compareFunc(a, b) {
            var aKey;
            var bKey;
            if (typeof (sortKey) === 'string') {
                if (sortKey === 'title') {
                    aKey = a['title'] || a['subtitle'];
                    bKey = b['title'] || b['subtitle'];
                }
                else {
                    aKey = a[sortKey];
                    bKey = b[sortKey];
                }
            }
            else {
                aKey = sortKey(a);
                bKey = sortKey(b);
            }
            // Ensure a stable sort by using updatedAt and objectId as a extra indexes
            if (aKey === bKey) {
                if (a.updatedAt !== b.updatedAt) {
                    aKey = a.updatedAt;
                    bKey = b.updatedAt;
                }
                else {
                    aKey = a.objectId;
                    bKey = b.objectId;
                }
            }
            // IKE4-2322 Explicitly compare against null and undefined, where equality is problematic.
            // e.g: 'a' > null (false), 'a' < null (false), 'a' == null (false)
            if (aKey == null || bKey == null) {
                if (aKey != null && bKey == null) {
                    return direction;
                }
                else if (aKey == null && bKey != null) {
                    return -1 * direction;
                }
                return 0;
            }
            else if (aKey > bKey) {
                return direction;
            }
            else if (aKey < bKey) {
                return -1 * direction;
            }
            return 0;
        }
        (0, timsort_1.sort)(objs, compareFunc);
        return objs;
    };
    SortableState.prototype.track = function () {
        var direction = this.direction === SortDirection.DESCENDING ? 'Descending' : 'Ascending';
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Sort', "".concat(this.option.title, ":").concat(direction));
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], SortableState.prototype, "direction", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SortableState.prototype, "option", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], SortableState.prototype, "isAscending", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SortableState.prototype, "toggleDirection", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SortableState.prototype, "setSort", null);
    return SortableState;
}());
exports.SortableState = SortableState;
var Sortable = /** @class */ (function (_super) {
    tslib_1.__extends(Sortable, _super);
    function Sortable(state) {
        var _this = _super.call(this) || this;
        _this.isOpen = false;
        _this.state = state;
        _this.menu = new menu_1.MenuComponent({
            items: function () { return _this.viewMenuItems(_this.state); }
        });
        return _this;
    }
    Object.defineProperty(Sortable.prototype, "nodes", {
        get: function () {
            var title = (0, index_1.Translate)(index_1.T.SORT_TITLE);
            var className = "mdl-button ".concat(exports.CSS.button);
            return mithril_1.m.fragment({}, [
                this.menu.view(),
                (0, mithril_1.m)('button', { className: className, onclick: this.menu.show, title: title }, [
                    (0, index_1.Translate)(this.state.option.title)
                ]),
                image_button_1.ImageButton.view(SortIcon[this.state.direction], { onclick: this.state.toggleDirection })
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Sortable.prototype.viewMenuItems = function (sortable) {
        var items = [];
        var _loop_1 = function (opt) {
            if (opt.visible != null && !opt.visible()) {
                return "continue";
            }
            items.push({
                selected: sortable.option.title === opt.title,
                view: menu_item_1.MenuItemComponent.view((0, index_1.Translate)(opt.title), opt.icon),
                action: function () { return sortable.setSort(opt); }
            });
        };
        for (var _i = 0, _a = sortable.options; _i < _a.length; _i++) {
            var opt = _a[_i];
            _loop_1(opt);
        }
        return items;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], Sortable.prototype, "isOpen", void 0);
    return Sortable;
}(mithril_component_1.IMithrilComponent));
exports.Sortable = Sortable;
//# sourceMappingURL=sortable.js.map